export default __webpack_public_path__ + "static/media/left-arrow.2e519130.svg";